module.exports = __webpack_public_path__ + "img/grow-with-traction.73a083f5.svg";